import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NAVY = "#132a63";
const GREEN = "#8CE313";

export default function NotFound() {
  return (
    <div style={{ minHeight: "100vh", background: NAVY, color: "white", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Poppins',system-ui,sans-serif", textAlign: "center" }} data-testid="notfound-page">
      <Helmet><title>Página no encontrada — Mi Ángel Asís</title></Helmet>
      <div style={{ maxWidth: 420 }}>
        <div style={{ fontSize: 72, fontWeight: 900, color: GREEN, lineHeight: 1 }}>404</div>
        <h1 style={{ fontSize: 22, fontWeight: 800, marginTop: 8 }}>No encontramos esta página</h1>
        <p style={{ color: "#cbd5e1", marginTop: 8, fontSize: 15 }}>
          El enlace que abriste no existe o cambió de dirección.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap", marginTop: 22 }}>
          <Link to="/" data-testid="notfound-home"
            style={{ background: GREEN, color: NAVY, padding: "12px 22px", borderRadius: 999, fontWeight: 800, textDecoration: "none" }}>
            Ir al inicio
          </Link>
          <Link to="/cuenta/login" data-testid="notfound-login"
            style={{ background: "transparent", color: "white", border: "1px solid rgba(255,255,255,0.4)", padding: "12px 22px", borderRadius: 999, fontWeight: 700, textDecoration: "none" }}>
            Iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
